<template>
  <div v-if="this.$store.state.app.isNeedCookie && !this.$store.getters.agreeCookie" class="cookie-frame">
    <div>
      {{ $t("Bao.cookie_content") }}
    </div>
    <div class="cookie-btn-frame">
      <button type="button" class="btn btn-style-primary btn-policy" @click="acceptCookie">
        {{ $t("Bao.cookie_accept") }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookieAgree',
  methods: {
    acceptCookie() {
      this.$store.commit('SET_IS_AGREE_COOKIE', true)
      // Store the preference in a cookie
      document.cookie = 'isAgreeCookie=true; path=/'
    }
  }
}
</script>
